import { ParseAdapter } from '../abstract/ParseAdapter';
import { Tchekb } from './tchekb.model';

export class Folder extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }

    get orderCam(): number { return this.parseObject.get('orderCam'); }
    set orderCam(value: number) { this.parseObject.set('orderCam', value); }

    get toDownload(): number { return this.parseObject.get('toDownload'); }
    set toDownload(value: number) { this.parseObject.set('toDownload', value); }

    get isUploaded(): boolean { return this.parseObject.get('isUploaded'); }
    set isUploaded(value: boolean) { this.parseObject.set('isUploaded', value); }

    get name(): string { return this.parseObject.get('name'); }
    set name(value: string) { this.parseObject.set('name', value); }

    get uploadHDPictures(): boolean { return this.parseObject.get('uploadHDPictures'); }
    set uploadHDPictures(value: boolean) { this.parseObject.set('uploadHDPictures', value); }

    get isDownloaded(): boolean { return this.parseObject.get('isDownloaded'); }
    set isDownloaded(value: boolean) { this.parseObject.set('isDownloaded', value); }

    get useMasterKey(): boolean { return this.parseObject.get('useMasterKey'); }
    set useMasterKey(value: boolean) { this.parseObject.set('useMasterKey', value); }

    get tchekPtr(): Tchekb { return new Tchekb(this.parseObject.get('tchekPtr')); }
    set tchekPtr(value: Tchekb) { this.parseObject.set('tchekPtr', value.getParseInstance()); }

    get totalPictures(): number { return this.parseObject.get('totalPictures'); }
    set totalPictures(value: number) { this.parseObject.set('totalPictures', value); }

    get descCam(): string { return this.parseObject.get('descCam'); }
    set descCam(value: string) { this.parseObject.set('descCam', value); }

    get webObjectId(): string { return this.parseObject.get('webObjectId'); }
    set webObjectId(value: string) { this.parseObject.set('webObjectId', value); }

    toPercentage(pictureNumber: number): number {
        console.log('click damage : ', this.totalPictures, pictureNumber);
        return (Math.ceil((pictureNumber / this.totalPictures) * 100));
    }
}



// WEBPACK FOOTER //
// ./src/app/model/folder.model.ts